export default __webpack_public_path__ + "static/media/logout.97ba577b.svg";